import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ProductionByStreetService } from 'src/app/modules/dashboard/services/production-by-street/production-by-street.service';
import { ProductionByTypetruckService } from 'src/app/modules/dashboard/services/production-by-typetruck/production-by-typetruck.service';
import { IResponseLapExtractionModal } from 'src/app/modules/widget/interfaces/production-type-truck-point';
import { ProductionByStreetModalComponent } from '../../production-by-street/production-by-street-modal/production-by-street-modal.component';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { RowThickness } from 'projects/common/src/app/components/table/table';
import { AuthenticationService } from 'projects/authentication/src/app/services';

@Component({
  selector: 'app-prod-by-typetruck-modal',
  templateUrl: './prod-by-typetruck-modal.component.html',
  styleUrls: ['./prod-by-typetruck-modal.component.scss'],
})
export class ProdByTypetruckModalComponent extends ProductionByStreetModalComponent implements OnInit, OnDestroy {
  public modalDataTypeTruck: IResponseLapExtractionModal;
  public tableConfig: ITableConfig;
  public data: any;

  constructor(
    public activeModal: NgbActiveModal,
    protected prodByStreetService: ProductionByStreetService,
    protected prodbyTypeTruck: ProductionByTypetruckService,
    protected prodByModel: ProductionByTypetruckService,
    protected langService: LanguageService,
    private tableService: TableConfigService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected authService: AuthenticationService,
  ) {
    super(activeModal, prodByStreetService, prodByModel, langService, googleAnalyticsService, authService);
  }

  async ngOnInit(): Promise<void> {
    this.modalDataTypeTruck = await this.prodbyTypeTruck.getLoopsByMachineModelAndExtractionPointDetail(
      this.date,
      this.shift.shiftId,
      this.streetId,
    );

    const dataTable = this.getDataByModelTable();
    this.setTableDetailConfig(dataTable);
    const modal = {
      modal_widget: 'production-by-typetruck',
    };
    this.googleAnalyticsService.sendCustomEvent('modal', modal);

    // 👮🏽 subscribe to the token expired event to close the modal
    this.logoutSub = this.authService.tokenExpired$.subscribe(() => {
      this.activeModal.dismiss('logout');
    });
  }

  public ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.logoutSub) {
      this.logoutSub.unsubscribe();
    }
  }

  /**
   * get data production by type truck modal table stadistics
   */
  public getDataByModelTable(): any {
    return this.modalDataTypeTruck.lapsByMachineAndExtractionList.map((machineLap) => {
      const { machineName } = machineLap;
      const obj = {};
      let sum = 0;
      const machineNameTranslation = this.langService.message('device').toUpperCase();
      Object.assign(obj, { [machineNameTranslation]: machineName });

      machineLap.loopMachine.forEach((loop) => {
        const key = loop.extractionPoint;
        if (!obj[key]) {
          obj[key] = 0;
        }
        obj[key] += loop.laps;
        sum += loop.laps;
      });

      Object.assign(obj, { total: sum });
      return obj;
    });
  }

  /**
   * config table Detail Production by type Truck
   *
   * @param tableData config data minute a minute
   */
  private setTableDetailConfig(tableData: any[]): void {
    const extraParams: ITableExtraParams = {
      rowThickness: RowThickness.Thin,
    };

    const headerParams: ITableHeaderParams = {
      data: tableData,
      translatable: false,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      colorConfig: [{ field: 'total', isBold: true }],
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => {
      this.tableConfig = { header, dataset, extraParams };
    }, 0);
  }

  public changeTab($event) {
    let customEvent = {};
    if ($event.index === 0) {
      customEvent = {
        tab_modal: 'production-by-typetruck_chart',
      };
    }
    if ($event.index === 1) {
      customEvent = {
        tab_modal: 'production-by-typetruck_table',
      };
      this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
    }
  }
}
